export default __webpack_public_path__ + "static/media/JobHack.5aeea454.svg";